/* eslint-disable no-unused-vars */
import React from 'react'
import flask from '../images/flask.jpg'
import flask1 from '../images/flask1.jpg'
import flask2 from '../images/flask2.jpg'
import flask3 from '../images/flask3.jpg'
import GooeyButton from './GooeyButton'
import { serumAddress,serumAbi } from '../contracts/serums'
import claimSignatures from  "../signatures/claim";
import {MinusIcon,PlusIcon} from '@heroicons/react/outline'
import { flushSync } from 'react-dom'
// import { LoremIpsum } from 'react-lorem-ipsum';
import "./Burn.scss"
import { BigNumber, ethers } from 'ethers'

const amountOwned = [

    {
        name: "Flask of Sleepiness",
        id:0,
        amount_claimable: 0,
        src: flask,
        // price: BigNumber.from(10).pow(14).mul(5)

        price:BigNumber.from(10).pow(18).mul(100)
        //18
    },
    {
        name: "Vial of Sleep",
        id:1,
        amount_claimable: 0,
        src: flask1,        
        // price: BigNumber.from(10).pow(14).mul(5)

        price:BigNumber.from(10).pow(16).mul(4)
        //16

    },
    {
        name: "Ether Elixir",
        id:2,
        amount_claimable: 0,
        src:flask2,
        // price: BigNumber.from(10).pow(14).mul(5)

        price:BigNumber.from(10).pow(15).mul(55)
        //15

    },
    {
        name: "777 Vessel",
        id:3,
        amount_claimable: 0,
        src: flask3,
        // price: BigNumber.from(10).pow(14).mul(5)
        price:BigNumber.from(10).pow(18).mul(1000)
 
    }
]

function getIdFromName(name){
    if(name === 'Flask of Sleepiness'){
        return 1
    }
    if(name === "Vial of Sleep"){
        return 2;
    }
    if(name === "Ether Elixir"){
        return 3;
    }
    if(name === "777 Vessel"){
        return 4;
    }
}
const OgBuy = () => {
    const[ogStatus,setOgStatus] = React.useState(false);
    const[alreadyClaimed,setAlreadyClaimed] = React.useState(false);
    const[connected,setConnected] = React.useState(false);
    const[purchaseArray,setPurchaseArray] = React.useState([0,0,0,0]);
    const[pass0,setPass0] = React.useState(0)
    const[pass1,setPass1] = React.useState(0)
    const[pass2,setPass2] = React.useState(0)
    const[pass3,setPass3] = React.useState(0)



    function incrementPurchaseArrayByIndex(index) {
        if(index===0) setPass0(pass0+1)
        if(index===1) setPass1(pass1+1)
        if(index===2) setPass2(pass2+1)
        if(index===3) setPass3(pass3+1)

    }
    function decrementPurchaseArrayByIndex(index) {
        
        if(index===0 && pass0>0) setPass0(pass0-1)
        if(index===1 && pass1>0) setPass1(pass1-1)
        if(index===2 && pass2>0) setPass2(pass2-1)
        if(index===3 && pass3>0) setPass3(pass3-1)

    }
  
//todo: (serumId,amount)
    const purchaseSerum = async (id,price,amount) => {
        try {
            if(amount <=0) return;
            const provider = new ethers.providers.Web3Provider(window.ethereum) ;
            const signer = provider.getSigner();
            const userAddress = await signer.getAddress();
            const serums = new ethers.Contract(serumAddress,serumAbi,signer);

     
            const purchase = await serums.ogBuy(id,amount,{value:price.mul(amount)});

            
        } catch (err) {
            console.log(err);
            
        }
      
    }
    const connectHandler = async () => {
        if(window.ethereum){
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            await provider.send("eth_requestAccounts",[]);
            const accounts = await provider.listAccounts();
            if(accounts.length>0){
                setConnected(true);
                const userAddress = accounts[0];
                const user = claimSignatures.find(obj => obj.address === userAddress);
                console.log(user);
                if(!user || user == null){
                    setOgStatus(false);
                    return;
                }
                else{
                    setOgStatus(true);                  
                }

                return
            }
        }
    }

    async function runOnRender() {
        if(!window.ethereum){
            return;
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const serums = new ethers.Contract(serumAddress,serumAbi,provider);
        const accounts = await provider.listAccounts();

        if(accounts.length>0){
            setConnected(true);
            const currUser = accounts[0];
            const checkClaim = await serums.hasBatchClaimed(currUser)
            if(checkClaim === true){
                setAlreadyClaimed(true);
              
            }
            const currObj = claimSignatures.find(user => user.address === currUser);
            if(!currObj || currObj == null) {
                
                return;
            }
            else{
               

                setOgStatus(true);
                
            }

        }
    }

    React.useEffect(() => {
        runOnRender();
    
     
    }, [])
    

  return (
      <>

    <div class=' w-screen mb-6 text-justify'>
    <div class='mt-12 flex flex-col m-auto  max-w-2xl'>
        <h1 class='text-center font-bold text-3xl mb-2'>Purchase A Serum</h1>
        <p class='text-center text-lg '>At this point in time only members who have batch claimed are eligible to purchase serums.</p>

        {/* <LoremIpsum p={1}/> */}
    </div>
    </div>
    

    <div class=' grid grid-cols-1 gap-y-8 sm:grid-cols-2 lg:grid-cols-4  place-items-center'>
        


        {amountOwned.length>0 && amountOwned.map((data)=>{
            return(
             <div onClick={()=>{
                if(connected === true){
             
                }
                else{
                    connectHandler();
                }
             }} class=''> 
             <img  class={`h-64 expand ${data.amount_claimable>0? "animate-pulse":""} m${getIdFromName(data.name)}`} src={data.src}></img>
             <br></br>
             <div class='text-center'>
                 <h1 class='mb-2 font-semibold'>{data.name}</h1>

                <span className='flex flex-row justify-around'>
                    <p
                    onClick={() => decrementPurchaseArrayByIndex(data.id) } 
                    className=' text-2xl h-8 w-8 text-center text-black bg-blue-500 rounded-lg cursor-pointer select-none'>-</p>
                    <p>
                        
                    {`
                    ${data.id === 0 ? `${pass0}` : ""}
                    ${data.id === 1 ? `${pass1}` : ""}
                    ${data.id === 2 ? `${pass2}` : ""}
                    ${data.id === 3 ? `${pass3}` : ""}
                    `


                    } </p>
                    <p 
                     onClick={() => incrementPurchaseArrayByIndex(data.id)} 
                    className=' text-2xl h-8 w-8 text-center text-black bg-blue-500 rounded-lg cursor-pointer select-none'>+</p>

                </span>
                
                 <p className='mb-2'>{parseInt(data.price.toString()) / 1e18} ETH</p>

                 <div onClick={()=>{
                    let amount;
                    if(data.id == 0) amount = pass0;
                    if(data.id == 1) amount = pass1;
                    if(data.id == 2) amount = pass2;
                    if(data.id == 3) amount = pass3;
                    console.log(amount);

                    purchaseSerum(data.id,data.price,amount)
                    
                    
                    }}>
                 <GooeyButton  
                    text={`
   
                       ${connected == false? "Connect Wallet" : "Purchase"}
   
                    
                    
                    `}/>              
                    </div>
                 </div>
         </div>
        )})}
  

    </div>
    </>
  )
}

export default OgBuy